export enum SearchMode {
    START_WITH = 'start_with',
    CONTAINS = 'contains',
}
